import { useCheckoutStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreCheckoutComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import clsx from "clsx";
import defaultStyles from "./CheckoutTitleSection.module.scss";

export interface CheckoutTitleSectionComponentProp
  extends PlatformComponentProps {
  title?: string;
  subtitle?: string;
}
export const CheckoutTitleSection = ({
  title,
  subtitle,
  className,
}: CheckoutTitleSectionComponentProp) => {
  const COMPONENT_KEY = CoreCheckoutComponent.CheckoutTitleSection;
  const styles = useCheckoutStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, className)}>
      {title ? <div className={cn("title")}>{title}</div> : null}
      {subtitle ? <div className={cn("subtitle")}>{subtitle}</div> : null}
    </div>
  );
};
